<ngx-spinner type="ball-scale-multiple" size="medium" [name]="blockLoader"></ngx-spinner>
<h1 mat-dialog-title>Enter Details</h1>
<div mat-dialog-content>
  <div class="name_field">
    <p>Name</p>
    <input matInput [(ngModel)]="name" required>
  </div>

    <div *ngFor="let task of jobs; let i = index">
      <section class="example-section">
        <span class="example-list-section">
          <mat-checkbox class="example-margin" [checked]="allCompleteJobs(i)" [indeterminate]="someComplete(i)" (change)="setAll($event.checked, i)">
            {{task.name}}
          </mat-checkbox>
        </span>
        <span class="example-list-section">
          <ul *ngIf="task.subMenu">
            <li *ngFor="let subtask of task.subMenu">
              <mat-checkbox [(ngModel)]="subtask.active" (ngModelChange)="updateAllComplete(i)">
                <span style="font-size: 14px !important">{{subtask.name}}</span>
              </mat-checkbox>
            </li>
          </ul>
        </span>
      </section>
    </div>
</div>

<div mat-dialog-actions style="display: flex;justify-content: flex-end;">
	<button mat-button mat-dialog-close>Cancel</button>
	<button mat-button cdkFocusInitial (click)="saveRole()">Save</button>
</div>